export class SizeRequest{
    sizeId:number;
    
    constructor(sizeId:number){
        this.sizeId = sizeId;
    }
}